import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [

  //401
  {
    path: "/401",
    name: "401",
    component: () => import("@/views/err/401.vue"),
  },
  //首页
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/index.vue"),
  },
  {
    path: "/report",
    name: "report",
    component: () => import("@/views/home/report/report.vue"),
  },
  {
    path: "/questionnaire",
    name: "questionnaire",
    component: () => import("@/views/home/questionnaire/questionnaire.vue"),
  },
  {
    path: "/affirm",
    name: "affirm",
    component: () => import("@/views/home/questionnaire/affirm.vue"),
  },
  {
    path: "/queryReport",
    name: "queryReport",
    component: () => import("@/views/home/questionnaire/queryReport.vue"),
  },
  {
    path: "/reportDetail",
    name: "reportDetail",
    component: () => import("@/views/home/report/reportDetail.vue"),
  },
  // 问卷中转页
  {
    path: "/RedirectGuard",
    name: "RedirectGuard",
    component: () => import("@/views/home/questionnaire/RedirectGuard.vue"),
  },
  //文章列表
  {
    path: "/artcileList",
    name: "artcileList",
    component: () => import("@/views/home/artcilelist.vue"),
  },
  //文章列表详情
  {
    path: "/artciledetail",
    name: "artciledetail",
    component: () => import("@/views/home/artciledetail.vue"),
  },
  // 登录
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register/register.vue')
  },
  // 实名认证
  {
    path: "/realName",
    name: "realName",
    component: () => import("@/views/my/myselfmess/realName.vue"),
  },
  // 个人信息
  {
    path: "/myselfmess",
    name: "myselfmess",
    component: () => import("@/views/my/myselfmess/myselfmess.vue"),
  },
  //文章详情
  {
    path: "/artciledetail",
    name: "artciledetail",
    component: () => import("@/views/home/artciledetail.vue"),
  },
  //评估报告
  {
    path: "/nutritionReport",
    name: "nutritionReport",
    component: () => import("@/views/home/nutritionReport/nutritionReport.vue"),
  },
];


const router = new VueRouter({
  routes,
});


router.beforeEach((to, from, next) => {
  // 如果目标页面是 /401，直接放行，避免死循环
  if (to.path === '/401') {
    return next();
  }

  // 检测是否在微信浏览器中
  const userAgent = navigator.userAgent.toLowerCase();
  const isInWeChat = userAgent.includes('micromessenger');

  if (!isInWeChat) {
    // 不在微信中 → 跳转到 401 页面
    console.log('当前不在微信中，跳转至 /401');
    next('/401');
  } else {
    // 在微信中 → 放行
    next();
  }
});

export default router;
